import React, { useEffect, useMemo, useRef, useState } from 'react'
import styled, { css, keyframes } from 'styled-components'
import CloseIcon from '@mui/icons-material/Close'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import AssistantOutlinedIcon from '@mui/icons-material/AssistantOutlined'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { getSelectedBp } from '../../ducks/selectors'
import { isOnline as checkIsOnline } from 'ducks/offline/actions'

const AddMultipleFilesModal = ({
  externalBpId,
  children,
  initialCategory,
  initialType,
  templateId,
  unit,
  isPrivate,
  addedFilesCount,
  fullWidth = false,
  method = 'traditional'
}) => {
  const selectedBp = useSelector(getSelectedBp)
  const bp = useMemo(
    () => ({
      id: externalBpId || (selectedBp && selectedBp.id)
    }),
    [externalBpId, selectedBp]
  )

  const handleClick = () => {
    if (!checkIsOnline()) {
      toast.warning('File upload is not available while offline.')
      return
    }
    const params = new URLSearchParams({ method })
    if (initialCategory) params.append('category', initialCategory)
    if (initialType) params.append('type', initialType)
    if (templateId) params.append('templateId', templateId)
    if (unit) params.append('unit', unit.id)
    if (isPrivate) params.append('private', 'true')
    
    const url = `/files/upload/${bp.id}?${params.toString()}`
    const newWindow = window.open(url, '_blank')
    newWindow.focus()
  }

  return <Trigger $fullWidth={fullWidth} onClick={handleClick}>{children}</Trigger>
}

export default AddMultipleFilesModal

const Trigger = styled.div`
  cursor: pointer;
  display: ${({ $fullWidth }) => ($fullWidth ? 'block' : 'inline-flex')};
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
  align-items: center;
  justify-content: center;
`
